(function () {
  'use strict';

  // ─────────────────────────────────────────────────────────────────────────
  // Läuft nur auf Produkten mit dem Shopify-Tag: ai-name-injection
  //
  // Liest den Hundenamen aus dem teeinblue-Feld mit custom CSS-Klasse
  // "ai-inject-field" und ersetzt den Platzhalter CUSTOM im AI-Prompt
  // bevor der Request an teeinblues image-filter-effects-Endpoint geht.
  //
  // Setup in teeinblue Admin:
  //   - Text-Feld "Dog Name" → Custom CSS class: ai-inject-field
  //   - Im AI-Prompt das Wort CUSTOM als Platzhalter nutzen,
  //     z. B.: "A watercolor portrait of CUSTOM the dog"
  // ─────────────────────────────────────────────────────────────────────────

  var PLACEHOLDER = 'CUSTOM';

  function getPetName() {
    var wrapper = document.querySelector('.ai-inject-field');
    if (!wrapper) return '';
    var el = wrapper.querySelector('input');
    return el ? el.value.trim() : '';
  }

  function injectName(formData, url) {
    var petName = getPetName();
    console.log('[hb-injector] injectName called, url=', url, 'petName=', petName);
    if (!petName) return;
    if (url.indexOf('lyto-imagegen-api') !== -1) {
      console.log('[hb-injector] setting pet_name on FormData');
      formData.set('pet_name', petName);
    } else {
      var effects = formData.get('effects');
      if (effects) {
        formData.set('effects', effects.split(PLACEHOLDER).join(petName));
      }
    }
  }

  // ── 1. fetch intercepten ─────────────────────────────────────────────────
  var _fetch = window.fetch;
    window.fetch = function (input, init) {
    init = init || {};
    var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
    if ((url.indexOf('image-filter-effects') !== -1 || url.indexOf('lyto-imagegen-api') !== -1) && init.body instanceof FormData) {
      injectName(init.body, url);
    }
    return _fetch.call(this, input, init);
  };

  // ── 2. XHR intercepten (Fallback) ────────────────────────────────────────
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._tibUrl = url || '';
    return _open.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this._tibUrl.indexOf('image-filter-effects') !== -1 && body instanceof FormData) {
      injectName(body, this._tibUrl)
    }
    return _send.apply(this, [body]);
  };

})();
